import { render, staticRenderFns } from "./VpnReservedDetail.vue?vue&type=template&id=48b20c28&"
import script from "./VpnReservedDetail.vue?vue&type=script&lang=ts&"
export * from "./VpnReservedDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports